import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TokenService } from '../services/common/token.service';
import { BaseService } from '../services/common/base.service';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DepartmentDashboardService extends BaseService {

  protected http: HttpClient;

  constructor(http: HttpClient, tokenService: TokenService) {
    super(tokenService);
    this.http = http;
  }

  GetDepartmentDashboard(userId: String, appType: String) {
    // return this.http.get<any>(`${environment.apiUrl}DashBoard/GetFarmerApplicationForApproval?UserId=${userId}`, { headers: this.buildHeadersNew() });
    return this.http.get<any>(`${environment.apiUrl}DashBoard/GetFarmerApplicationForApproval?UserId=${userId}&AppType=${appType}`);
  }


  GetStatusMaster(userId, actionId) {
    // return this.http.get<any>(`${environment.apiUrl}DashBoard/GetStatusMaster?Userid=${userId}&ActionId=${actionId}`, { headers: this.buildHeaders() });
    return this.http.get<any>(`${environment.apiUrl}DashBoard/GetStatusMaster?Userid=${userId}&ActionId=${actionId}`);
  }

  InsertFarmerApplicationApprovalRemarks(appId: String, userId: String, remarks: String, statusValue: String) {
    // return this.http.post(`${environment.apiUrl}DashBoard/InsertFarmerApplicationApprovalRemarks?AppId=${appId}&Userid=${userId}&Remarks=${remarks}&Status=${statusValue}`, { headers: this.buildHeaders() }, {responseType: 'text'});
    return this.http.post(`${environment.apiUrl}DashBoard/InsertFarmerApplicationApprovalRemarks?AppId=${appId}&Userid=${userId}&Remarks=${remarks}&Status=${statusValue}`, {responseType: 'text'});
  }

  getVendorMIEstimationsForApproval(userId, actionType) {
    // return this.http.get<any>(`${environment.apiUrl}DashBoard/GetVendorMIEstimateForApproval?UserId=${userId}`, { headers: this.buildHeaders() });
    return this.http.get<any>(`${environment.apiUrl}DashBoard/GetVendorMIEstimateForApproval?UserId=${userId}&AppType=${actionType}`);
  }

  getVendorMIEstimation(appId, vendorRegId, progId) {
    // return this.http.get<any>(`${environment.apiUrl}DashBoard/GetVendorMIEstimation?AppId=${appId}&VendorRegId=${vendorRegId}&ProgID=${progId}`, { headers: this.buildHeaders() });
    return this.http.get<any>(`${environment.apiUrl}DashBoard/GetVendorMIEstimation?AppId=${appId}&VendorRegId=${vendorRegId}&ProgID=${progId}`);
  }

  getVendorMIBOQ(appId, vendorRegId, progId){
    return this.http.get<any>(`${environment.apiUrl}DashBoard/GetVendorMIBOQ?AppId=${appId}&VendorRegId=${vendorRegId}&ProgId=${progId}`);
  }

  insertVendorMIEstimateForApproval(appId: String, userId: String, remarks: String, statusValue: String, programId: String){
    // return this.http.get<any>(`${environment.apiUrl}DashBoard/InsertVendorMIEstimateForApproval?AppId=${appId}&Userid=${userId}&Remarks=${remarks}`, { headers: this.buildHeaders() });
    return this.http.post(`${environment.apiUrl}DashBoard/InsertVendorMIEstimateForApproval?AppId=${appId}&Userid=${userId}&Remarks=${remarks}&Status=${statusValue}&ProgId=${programId}`, {responseType: 'text'});
  }


  workFlowAllStatus(appId: string){
    return this.http.get<any>(`${environment.apiUrl}Vendor/WorkFlowAllStatus?AppID=${appId}`);
  }

  
  dashboardSummaryReport(){
    return this.http.get<any>(`${environment.apiUrl}Reports/DashboardSummaryReport`);
  }

  printMultipleChallanAtal(reqBody){
    return this.http.post(`${environment.apiUrl}Challan/PrintMultipleChallanAtal`, reqBody);
  }

  getApplicationsForMISubsidyLot(userId: String) {
    return this.http.get<any>(`${environment.apiUrl}Department/GetApplicationsForMISubsidyLot?UserId=${userId}`);
  }
  
  insertMISubsidyLot(reqBody){
    return this.http.post(`${environment.apiUrl}Department/InsertMISubsidyLot`, reqBody);
  }

  getDataToPrintMultipleChallanAtal(userId: String) {
    return this.http.post(`${environment.apiUrl}Challan/GetDataToPrintMultipleChallanAtal?RequestType=${userId}`, {});
  }

  approveOtherUsersChallan(reqBody){
    return this.http.post(`${environment.apiUrl}Department/ApproveOtherUsersChallan`, reqBody);
  }

  getApplicationsForMIFarmerShareToVendorLot(userId: String) {
    return this.http.get<any>(`${environment.apiUrl}Department/GetApplicationsForMIFarmerShareToVendorLot?UserId=${userId}`);
  }
  getApplicationsForMISubsidyToVendorLot(userId: String) {
    return this.http.get<any>(`${environment.apiUrl}Department/GetApplicationsForMISubsidyToVendorLot?UserId=${userId}`);
  }

  getApplicationsForMISubsidyToFarmerLot(userId: String) {
    return this.http.get<any>(`${environment.apiUrl}Department/GetApplicationsForMISubsidyToFarmerLot?UserId=${userId}`);
  }

  getApplicationsForMIRefundToFarmerLot(userId: String) {
    return this.http.get<any>(`${environment.apiUrl}Department/GetApplicationsForMIRefundToFarmerLot?UserId=${userId}`);
  }
  insertpondSubsidyLot(reqBody){
    return this.http.post(`${environment.apiUrl}Department/InsertPondSubsidyLot`, reqBody);
  }

  getDashboardIframeUrl(reqBody){
    return this.http.post(`${environment.apiUrl}DashBoard/GetDashboardIFrameURL`, reqBody);
  }

  //post
  postCountExportDataFrequency(reqBody){
    return this.http.post<any>(`${environment.apiUrl}Department/SaveMILotExportLog`, reqBody);
  }
  GetRealTimeDataofPDMCScheme() { 
    return this.http.get<any>(`${environment.apiUrl}DashBoard/MICanalTubewellApplication`);
  }
  GetMicroIrrigationSystem() {
    return this.http.get<any>(`${environment.apiUrl}DashBoard/GetPondCanalTubewellApplication`);
  }
  GetLineChartList() { 
    return this.http.get<any>(`${environment.apiUrl}DashBoard/GetCMDashboardYearWiseProgressMI`);
  }
  GetPieChartList() { 
    return this.http.get<any>(`${environment.apiUrl}DashBoard/GetCMDashboardYearWiseMIArea`);
  }
  getApplicationDataOfPreEstimation(appId, progId){
    return this.http.get<any>(`${environment.apiUrl}DashBoard/getApplicationDataOfPreEstimation?AppId=${appId}&ProgId=${progId}`);
  }
  
  getApplicationDataForPhysicalVer(autoId, userId){
    return this.http.get<any>(`${environment.apiUrl}DashBoard/GetApplicationDataForPhysicalVer?AutoId=${autoId}&UserId=${userId}`);
  }

  getDistWiseAvgTimeConsumed(){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetDistWiseAvgTimeConsumed`);
  }

  getDistWiseAvgTimeConsumedProgram(reqBody){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetDistWiseAvgTimeConsumedProgram?District=${reqBody.District}&Program=${reqBody.Program}`);
  }


  getWorkflowAllStatusByAppId(reqBody){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetWorkflowAllStatusByAppId?AppId=${reqBody.AppId}&Program=${reqBody.Program}`);
  }
}
